export enum IslandType {
  Class,
  Home,
}
